module.exports = __webpack_public_path__ + "img/page-not-found.fe432c6b.svg";